import { render, staticRenderFns } from "./CWcomplainList.vue?vue&type=template&id=eb0d2fde&scoped=true&"
import script from "./CWcomplainList.vue?vue&type=script&lang=js&"
export * from "./CWcomplainList.vue?vue&type=script&lang=js&"
import style0 from "./CWcomplainList.vue?vue&type=style&index=0&id=eb0d2fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0d2fde",
  null
  
)

export default component.exports